import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "@env/environment";
import { map } from "rxjs/operators";
import { SoignantIndicateursResponseModel } from "@core/layout/components/top-bar/models/soignant-indicateurs-response.model";

@Injectable({
	providedIn: "root",
})
export class MessageCountApiService {
	private readonly http = inject(HttpClient);

	getCountV2(soignantId: number): Observable<number> {
		return this.http
			.post<SoignantIndicateursResponseModel>(`${environment.apiEmotion()}/v2/soignants/indicateurs`, {
				soignantIds: [soignantId],
				paramNombreMessageNonLus: {
					execute: true,
				},
			})
			.pipe(
				map(({ soignantIndicateurs }) => {
					const count = soignantIndicateurs.find(
						(item) => +item.soignantId === soignantId,
					)?.nombreMessageNonLus;
					if (count === undefined) {
						throw new Error("Soignant non trouvé dans la réponse des indicateurs");
					}
					return count;
				}),
			);
	}

	getCountPs(situationId: number): Observable<string> {
		return this.http.put<string>(
			`${environment.apiEmotion()}/transmissioncabinet/countTransmissionCabinetNonLues/${situationId}`,
			null,
			{
				responseType: "text" as "json",
			},
		);
	}

	getCountRemplacant(remplacantSituationId: number): Observable<string> {
		return this.http.put<string>(
			`${environment.apiEmotion()}/transmissioncabinet/countTransmissionCabinetNonLuesRemplacant/${remplacantSituationId}`,
			null,
			{
				responseType: "text" as "json",
			},
		);
	}
}
